<template>
    <section>
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen">
                <div class="flex justify-between pl-10 pr-10 pt-5 md:flex-col-reverse md:p-2">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">ADMIN WALLET</p>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>
                
                <section class="mt-10 p-2">

                    <div class="flex md:text-sm">
                        <div @click="goBack" class="flex text-blue-700">
                            <i class="fa fa-arrow-left mr-3 mt-1"></i>
                            <p>Go Back</p>
                        </div>

                        <div class="ml-6">
                            <p class="text-xl font-semibold">Transaction History</p>
                        </div>
                    </div>
                    
                    <div class="mt-10" ref="Download">
                        
                            <div >
                                <div class="flex mt-2">
                                    <p class="w-1/3">Reference</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.txRef}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Receiver's Name</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.recieverName}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Bank Name</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.bankName}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Transaction Status</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.status}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Amount</p>
                                    <p class="w-1/3 text-blue-700">NGN{{transDetails.amount}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Description</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.description}}</p>
                                </div>
                                <div class="flex mt-2">
                                    <p class="w-1/3">Account Number</p>
                                    <p class="w-1/3 text-blue-700">{{transDetails.accountNumber}}</p>
                                </div>
                            </div>

                        <div class="flex mt-8 text-white">
                            <button @click="print" class="w-1/6 p-2 md:w-1/2 rounded-lg" style="background-color:#0048AE" >Print Receipt</button>
                        </div>
                    </div>
                </section>  
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../../AdminDashboardNav.vue';
import GetDate from '../../GetDate.vue';
import Notification from '../../Notification.vue';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    props: ["id"],
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
    },
    data() {
        return {
            transDetails:[],
            token: localStorage.getItem("token")
            
        }
    },
    mounted() {
        this.getTransactionDetails();
    },

    methods: {
        goBack() {
           this.$router.go(-1)
        },

        getTransactionDetails() {
            axios({
              method: 'GET',
              url: `${url}/v1/web/transactions/info/${this.id}`,
              headers: {
                  'Content-type': 'application/json',
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
              }
          })
          .then((res) => {
              this.transDetails = res.data.data;
              console.log(this.transDetails);
          })
          .catch((err)=>err.json)
        },

        print() {
            window.print();    
        },

    }
}
</script>

